var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleOrrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 112",
    cx: 6.6787,
    cy: 6.6787,
    r: 6.6787,
    fill: "#FD9843"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleOrrange);
export default __webpack_public_path__ + "static/media/icon_circle_orrange.58f23de162a7f6620dfbb7bf32a0ad6b.svg";
export { ForwardRef as ReactComponent };